import { Session } from '../../../../types';
import { DefineRequest } from '../../types';
import { core } from '../../apis';

export type GetMe = DefineRequest<void, Session>;

export const getMe: GetMe['request'] = () =>
  core.get({ accessToken: true }, '/me');
